import { render } from "./LineWithRibs.vue?vue&type=template&id=2cc5a4f0"
import script from "./LineWithRibs.vue?vue&type=script&lang=js"
export * from "./LineWithRibs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__